import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy } from '@atlassian/react-loosely-lazy';
import type { Props } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyNoPermissionViews = lazy(
	() =>
		import(/* webpackChunkName: "async-project-directory-no-permission-views" */ './index').then(
			({ NoPermissionViews }) => NoPermissionViews,
		),
	{ ssr: false },
);

export const AsyncNoPermissionViews = (props: Props) => (
	<Placeholder name="no-permission-views" fallback={null}>
		<LazyNoPermissionViews {...props} />
	</Placeholder>
);
